import { Alert, LoadingButton, TextField, Typography } from "@firecms/ui";
import { type AdminSetUserMailVerifiedResult } from "@repo/common";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import AdminToolPage from "components/molecules/AdminToolPage";
import { getErrorMessage } from "lib/error.utils";
import { setAdminUserMailVerified } from "services/admin-tools/adminTools";

const TOOL_DESCRIPTION =
  "Setzt `emailVerified` in Firebase Auth auf `true` — z. B. wenn ein Nutzer die Bestätigungsmail nicht erhalten hat. UID oder E-Mail-Adresse.";

const AdminSetUserMailVerified: React.FC = () => {
  const [identifier, setIdentifier] = useState("");

  const { data, error, isPending, mutate, reset } = useMutation<AdminSetUserMailVerifiedResult, Error, string>({
    mutationFn: setAdminUserMailVerified,
  });

  const handleSubmit = (): void => {
    const trimmedIdentifier = identifier.trim();
    if (!trimmedIdentifier) {
      return;
    }

    if (
      !window.confirm(
        `Bist du sicher, dass du die E-Mail für „${trimmedIdentifier}" als verifiziert markieren möchtest?`,
      )
    ) {
      return;
    }

    reset();
    mutate(trimmedIdentifier);
  };

  return (
    <AdminToolPage title="E-Mail verifizieren" description={TOOL_DESCRIPTION}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
        <TextField
          label="UID oder E-Mail"
          value={identifier}
          onChange={(event) => {
            setIdentifier(event.target.value);
          }}
          size="medium"
          className="flex-1"
        />
        <LoadingButton
          color="primary"
          loading={isPending}
          disabled={isPending || !identifier.trim()}
          onClick={handleSubmit}
        >
          Als verifiziert setzen
        </LoadingButton>
      </div>

      {error ? <Alert color="error">{getErrorMessage(error)}</Alert> : null}

      {data ? (
        <Alert color="success">
          <Typography variant="body2">
            UID <code>{data.uid}</code> — E-Mail verifiziert: <strong>{data.emailVerified ? "ja" : "nein"}</strong>
          </Typography>
        </Alert>
      ) : null}
    </AdminToolPage>
  );
};

export default AdminSetUserMailVerified;
